const AppConfigDefs = {
    app: {
        abreviatura: "SIN",
        nome: "Sistema de Inteligência de Negócio",
        empresa: "Fagron",
        footer: "Fagron Technologies - 2024"
    },
    login: {
        logo: {
            ligth: 'layout/fagron/images/logo-light.png',
            dark: 'layout/fagron/images/logo-dark.png',
            style: 'height: 44px;'
        },
        logoname: {
            ligth: 'layout/fagron/images/logo-nome-light.png',
            dark: 'layout/fagron/images/logo-nome-dark.png',
            style: 'width: 180px; padding-top: 12px;'
        }
    },
    topbar: {
        logo: {
            ligth: 'layout/fagron/images/logo-light.png',
            dark: 'layout/fagron/images/logo-dark.png',
            style: 'height:28px; padding-left: 7px;'
        },
        logoname: {
            ligth: 'layout/fagron/images/logo-nome-light.png',
            dark: 'layout/fagron/images/logo-nome-dark.png',
            style: 'padding-left: 5px; padding-top: 7px; height:40px;'
        }
    },
    theme: {
        colorScheme: 'light',
        menu: 'red',
        component: 'red',
        menuMode: 'horizontal'
    },
    sifm: true
};

export default AppConfigDefs;